import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, Grid, Stack, Tab, Tabs, Typography, tabsClasses } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import Label from "../../../components/Common/Label";
import CustomButton from "../../../components/Form/CustomButton";
import CustomIconButton from "../../../components/Form/CustomIconButton";
import Helpers from "../../../helpers/helpers";
import { getServiceList, getServiceListing } from "../../../store/actions";
import "../../Orders/order.css";
import ServicesFiled from "./ServicesFiled";

const Services = ({ setFormValues, values, error, servicesTab, setNotification, services_type, width }) => {
  const dispatch = useDispatch()
  const [filteredServiceListing, setServicesListing] = useState(services_type)

  useEffect(() => {
    setTabsData(servicesTab)
  }, [servicesTab]);

  useEffect(() => {
    setServicesListing(services_type)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [services_type]);

  const [openServicesField, setOpenServicesField] = useState(false)
  const [TabsData, setTabsData] = useState(servicesTab)
  const [editId, setEditId] = useState("")
  const [viewData, setViewData] = useState([])
  const [viewOpen, setViewOpen] = useState(false)
  const [edit, setEdit] = useState(false)
  const [tabValue, setTabValue] = useState(0)
  const [tabsDataArry, setTabDataArry] = useState({})
  const [errorEmpty, setError] = useState(false)
  const [errorYear, setErrorYearType] = useState(false)
  const [tempServices, setTempServices] = useState({
    service_type_name: "",
    years: "",
    options: [],
    default_option: false
  },)

  const [tempServicesEmpty, setTempServicesEmpty] = useState({
    service_type_name: "",
    years: "",
    options: [],
    default_option: false
  },)

  useEffect(() => {
    if (tabValue !== null && tabValue !== undefined && tabValue !== "") {
      // let tabID = Helpers.getTabIdFromIndex(servicesTab, tabValue)
      Helpers.getValueFromDataForTab(TabsData, tabValue, setTabDataArry)
    }
  }, [TabsData, servicesTab, tabValue, tabsDataArry.id]);

  useEffect(() => {
    if (tabsDataArry.id) {
      // dispatch(getServiceListing(payload))
      dispatch(getServiceList({ id: tabsDataArry?.id || "" }))
    }
  }, [tabsDataArry.id]);

  const handleDeleteFiles = (id) => {
    const tempFile = values?.product_services;

    if (!tempFile || tempFile.length === 0) {
      console.error("No items to delete");
      return; // Safeguard for empty or undefined `product_services`
    }

    // Filter the product_services array by tabsDataArry?.id
    const filteredServices = tempFile.filter(
      (service) => service.service_id === tabsDataArry?.id // Replace with your actual filtering logic
    );

    // Get the item to delete using the given index in the filtered array
    const itemToDelete = filteredServices[id];

    if (!itemToDelete) {
      return; // Safeguard for invalid id
    }

    // Find the real index of the item in the original array
    const realIndex = tempFile.findIndex((service) => service === itemToDelete);

    if (realIndex === -1) {
      console.error("Item not found in the original array");
      return; // Safeguard for unexpected issues
    }

    // Create a new array without the item at the real index
    const updatedServices = tempFile.filter((_, idx) => idx !== realIndex);

    // Update the form values with the filtered array
    setFormValues((prevValues) => ({
      ...prevValues,
      product_services: updatedServices,
    }));
  };


  const handleEditFiles = (id) => {
    const tempFile = values?.product_services;

    if (!tempFile || tempFile.length === 0) {
      return; // Safeguard for empty or undefined `product_services`
    }

    // Filter the array by the relevant criteria (e.g., tabsDataArry?.id or any other condition)
    const filteredFiles = tempFile.filter((x) => x.service_id === tabsDataArry?.id);

    if (id < 0 || id >= filteredFiles.length) {
      console.error("Invalid index for filtered files");
      return;
    }

    // Find the original item in `tempFile` based on the filtered array's item
    const originalItemIndex = tempFile.findIndex((x) => x === filteredFiles[id]);
    const originalItem = tempFile[originalItemIndex];

    if (originalItem) {
      // handleCheckDuplicate("Edit", originalItem?.years)

      setEdit(true);
      setEditId(id); // Use the index in the original array
      setTempServices(originalItem);
      setOpenServicesField(false)
    } else {
      console.error("Could not find the original item");
    }
  };

  const checking = (data) => {
    let validate = data?.years !== "" /*&& data?.options?.length > 0*/ && data?.price !== "" && data?.service_type_id !== ""
    // let validateOption = data?.years !== "" && data?.options?.length > 0 && data?.price !== ""
    // Validate all options have non-empty years and price
    const validateOptionItem = data?.options?.length > 0 ? data?.options?.every((x) => x?.years !== "" && x?.price !== "" && x?.service_type_name !== "") : true;
    console.log("dsfdfs", data, validate, validateOptionItem)

    if (!validate /* || !validateOption */ || !validateOptionItem) {
      setError(true)
      setNotification({
        open: true,
        msg: "Please complete the service section!",
        type: "warning",
      });
    }

    return (validate && /* validateOption && */ validateOptionItem)
  }

  const checkYear = (data) => {
    let validateYear = data?.options?.length > 0 ? data?.options?.every((x) => /^[0-9]/.test(x?.years)) : true;
    let validateZero = data?.options?.length > 0 ? data?.options?.every((x) => parseInt(x?.years) >= 1) : true;
    if (!validateZero) {
      setErrorYearType(true)
      setNotification({
        open: true,
        msg: "The duration field must be at least 1.",
        type: "warning",
      });
    } else if (!validateYear) {
      setErrorYearType(true)
      setNotification({
        open: true,
        msg: "Please make sure the years start with a number!",
        type: "warning",
      });
    }
    return validateYear && validateZero

  }

  const clear = () => {
    setErrorYearType(false)
    setError(false)
  }

  const handleSaveEdit = (id) => {
    let validate = checking(tempServices);
    let validateYear = tempServices?.options?.length > 0 ? checkYear(tempServices) : true;
    if (validate && validateYear) {
      setEditId(id);
      setFormValues((prevValues) => {
        const tempFile = prevValues.product_services;

        // Filter the product_services by tabsDataArry?.id
        const filteredServices = tempFile.filter(
          (service) => service.service_id === tabsDataArry?.id
        );

        // Get the item from the filtered array
        const filteredItem = filteredServices[id];

        // Find the real index in the original array
        const realIndex = tempFile.findIndex((service) => service === filteredItem);
        if (realIndex !== -1) {
          // Update the real index item
          const updatedServices = [...tempFile];
          updatedServices[realIndex] = {
            ...updatedServices[realIndex],
            service_id: tabsDataArry?.id,
            price: tempServices?.price,
            default_option: tempServices?.default_option,
            service_type_id: tempServices?.service_type_id,
            service_type_name: tempServices?.service_type_name,
            years: tempServices?.years,
            options: tempServices?.options,
            sku: tempServices?.sku,
          };
          return {
            ...prevValues,
            product_services: updatedServices,
          };
        } else {
          console.error("Item not found in the original array");
          return prevValues; // No update if index not found
        }
      });
      setTempServices({});
      setEditId("");
      setEdit(false);
      clear()
    }
  }

  // const handleCheckDuplicate = (type, cat_id) => {
  //   let tempAccessoriesData = values?.product_services

  //   if (type === "Add") {
  //     if (tempAccessoriesData?.length > 0) {
  //       const usedCategoryIds = tempAccessoriesData?.length > 0 && tempAccessoriesData?.map(item => item.service_type_id);
  //       const newFilteredCat = services_type?.length > 0 && services_type.filter(cat => !usedCategoryIds.includes(cat.id));
  //       setServicesListing(newFilteredCat || [])
  //     }
  //   } else {
  //     if (tempAccessoriesData?.length > 0) {
  //       let usedCategoryIds = tempAccessoriesData?.length > 0 && tempAccessoriesData?.map(item => item.service_type_id);
  //       usedCategoryIds = usedCategoryIds?.length > 0 && usedCategoryIds.filter(id => id !== cat_id);
  //       const newFilteredCat = services_type?.length > 0 && services_type.filter(cat => !usedCategoryIds?.includes(cat.id));
  //       setServicesListing(newFilteredCat || [])
  //     }
  //   }

  // }

  const handleAddServices = () => {
    let validate = checking(tempServicesEmpty);
    let validateYear = tempServicesEmpty?.options?.length > 0 ? checkYear(tempServicesEmpty) : true;
    if (validate && validateYear) {
      let temp = values?.product_services
      temp.push(
        {
          service_type_name: tempServicesEmpty?.service_type_name,
          service_type_id: tempServicesEmpty?.service_type_id,
          years: tempServicesEmpty?.years,
          service_id: tabsDataArry?.id,
          price: tempServicesEmpty?.price,
          options: tempServicesEmpty?.options,
          default_option: tempServicesEmpty?.default_option,
          sku: tempServicesEmpty?.sku,
        })
      setFormValues((prevValues) => ({
        ...prevValues,
        product_services: temp
      }))
      setTempServicesEmpty({})
      setOpenServicesField(false)
      clear()
    }
  }

  return (
    <React.Fragment>
      {/* {deleteModal()} */}
      <div className="">
        <Card className="p-3 px-2" style={{ minHeight: "40vh" }}>
          <CardBody>
            <div className="setting-header">SERVICES</div>
            {error && <FormHelperText sx={{ color: "red" }}>{error?.product_services || (error && Helpers?.getCustomErrorMessageByPrefix(error, "product_services."))}</FormHelperText>}
            <Divider className="my-2 mb-4" />
            {
              TabsData?.length ?
                <Grid container sx={{ border: { sm: '1px solid #D0D0D0', xs: "1px solid #D0D0D0" }, borderRadius: "5px" }} padding={{ sm: 2, xs: 2 }}>
                  <Grid item xs={12} style={{ width: width > 568 ? "auto" : "60vw" }} >
                    <Tabs value={tabValue} scrollButtons={true} onChange={(e, val) => (setTabValue(val), setOpenServicesField(false), setEditId(""))} aria-label="basic tabs example" variant="scrollable" TabIndicatorProps={{ style: { backgroundColor: 'var(--bs-theme-color)' } }}
                      sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                          '&.Mui-disabled': { opacity: 0.3 },
                        },
                      }}
                    >
                      {
                        TabsData && TabsData.length > 0 && TabsData.map((x, idx) =>
                          <Tab key={idx} label={<div className="d-flex" style={{ color: parseInt(tabValue) === idx ? '#282828' : '#A0A0A0' }}>{x.name}</div>} />
                        )
                      }</Tabs>
                  </Grid>
                  <Grid item xs={12} pt={{ xs: 1, sm: 2 }}>
                    <Stack direction={{ xs: "column", sm: "row" }} pt={2} gap={1} justifyContent={"space-between"}>
                      <Stack direction={"row"} gap={1} >
                        <div style={{ border: '1px solid #D0D0D0', borderRadius: "5px", height: "42px", width: "42px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                          <i className={tabsDataArry?.icon || ""} style={{ fontSize: "24px" }}></i>
                        </div>
                        <div>
                          <span className="setting-form-section-header" >{Helpers?.capitalizeWords(tabsDataArry?.name)}</span>
                          <Typography><span className="setting-form-subtitle">{values?.product_services?.filter((y, idx) => y.service_id === tabsDataArry?.id)?.length} options</span></Typography>
                        </div>
                      </Stack>
                      <Stack display={"contents"} justifyContent={{ xs: "flex-start", sm: "flex-end" }}>
                        <CustomButton
                          borderStyle={"1px solid #282828"}
                          title={"Add duration option"}
                          press={() => {
                            setOpenServicesField(true);
                            setEditId("");
                            // handleCheckDuplicate("Add");
                          }}
                          height={40}
                          backgroundColor={'white'}
                          textColor={'#282828'}
                        />
                      </Stack>
                    </Stack>
                  </Grid>
                  {/* card */}
                  <Grid item xs={12} pt={2} >
                    <Grid container spacing={1} style={{ minHeight: "30vh" }} >
                      {values?.product_services && values?.product_services.length > 0 ?
                        values?.product_services?.filter((y, idx) => y.service_id === tabsDataArry?.id).length > 0 ?
                          values?.product_services?.filter((y, idx) => y.service_id === tabsDataArry?.id).map((x, i) => {
                            return (
                              <React.Fragment key={i}>
                                {
                                  <Grid item xs={12} sm={6}>
                                    <div
                                      className="mt-1 mb-0"
                                      style={{ border: "1px solid #d0d0d0", borderRadius: "8px", padding: "10px", paddingTop: "15px", paddingBottom: "15px" }}
                                    >
                                      <Stack flexDirection={{ xs: "column", sm: "row" }} justifyContent={"space-between"}>
                                        <div className="p-2 w-100">
                                          <Stack direction={"row"} justifyContent={"space-between"} pb={1}>
                                            <Stack direction={"row"} style={{ fontFamily: 'Manrope', fontSize: 14, fontWeight: 600, color: "#282828", paddingBottom: "5px", marginLeft: "5px" }}>
                                              {x?.service_type_name || "-"} <br />
                                              {x?.years} Years (S$ {x?.price || 0})
                                              {
                                                x?.default_option == 1 && <Label.CustomLabel label={'Default Selected'} backgroundColor={"#F1F1F1"} marginLeft={"5px"} />
                                              }
                                            </Stack>
                                            {width > 598 &&
                                              <div className="d-flex justify-content-end">
                                                {/* <div><CustomIconButton
                                                  iconName={'ri-eye-line'}
                                                  onClick={(e) => (setViewOpen(true), handleViewServiceModal(x))} /></div> */}

                                                <div><CustomIconButton
                                                  iconName={'ri-pencil-line'}
                                                  onClick={(e) => handleEditFiles(i)}
                                                /></div>
                                                {
                                                  // x.default_option !== 1 &&
                                                  <div><CustomIconButton
                                                    iconName={'ri-delete-bin-line'}
                                                    onClick={(e) => handleDeleteFiles(i)}
                                                    backgroundColor={'#44d62c'}
                                                    color={'white'}
                                                    borderStyle={"1px solid #44d62c"}
                                                  /></div>}
                                              </div>}
                                          </Stack>
                                          {
                                            x?.options && x?.options.length > 0 && x?.options.map((y, idx) =>
                                              <Stack key={idx} className="d-flex" style={{ justifyContent: "space-between" }} direction={{ xs: "column", sm: "row" }} pb={1}>
                                                <span className="setting-form-subtitle">{y?.service_type_name} ({y?.years} yrs)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; +S${y?.price}</span>
                                                {
                                                  y?.default_option === 1 && <Label.CustomLabel label={'Default Selected'} backgroundColor={"#F1F1F1"} />
                                                }
                                              </Stack>
                                            )}
                                        </div>

                                      </Stack>
                                      {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefixCard(error, `product_services.${i}`)}</FormHelperText>}

                                      {width < 598 &&
                                        <div className="d-flex justify-content-end">
                                          {/* <div>
                                            <CustomIconButton
                                            iconName={'ri-eye-line'}
                                            onClick={(e) => (setViewOpen(true), handleViewServiceModal(x))} /></div> */}

                                          <div><CustomIconButton
                                            iconName={'ri-pencil-line'}
                                            onClick={(e) => handleEditFiles(i)}
                                          /></div>
                                          {
                                            !x.default_option &&
                                            <div><CustomIconButton
                                              iconName={'ri-delete-bin-line'}
                                              onClick={(e) => handleDeleteFiles(i)}
                                              backgroundColor={'#44d62c'}
                                              color={'white'}
                                              borderStyle={"1px solid #44d62c"}
                                            /></div>}
                                        </div>}
                                    </div>
                                  </Grid>

                                }
                                {
                                  edit && editId === i &&
                                  <Grid item xs={12}>
                                    <ServicesFiled setNotification={setNotification} width={width} setOpenServicesField={setOpenServicesField} tempServices={tempServices} error={errorEmpty} errorYear={errorYear} setTempServices={setTempServices} handleAddServices={handleAddServices} edit={edit} setEditId={setEditId} handleSaveEdit={handleSaveEdit} id={i} setEdit={setEdit} tabValue={tabValue} TabsData={TabsData} services_type={filteredServiceListing} tabDataArry={tabsDataArry} clear={clear}
                                    />
                                  </Grid>}

                              </React.Fragment>
                            );
                          })
                          :
                          !openServicesField && <span className="text-muted" style={{ width: "100%", textAlign: "center", alignSelf: "anchor-center" }}>No services added</span>
                        :
                        !openServicesField && <span className="text-muted" style={{ width: "100%", textAlign: "center", alignSelf: "anchor-center" }}>No services added</span>
                      }

                      {
                        openServicesField &&
                        <ServicesFiled width={width} setNotification={setNotification} setOpenServicesField={setOpenServicesField} tempServices={tempServicesEmpty} error={errorEmpty} errorYear={errorYear} setTempServices={setTempServicesEmpty} handleAddServices={handleAddServices} edit={false} setEditId={setEditId} tabValue={tabValue} TabsData={TabsData} services_type={filteredServiceListing} tabDataArry={tabsDataArry} clear={clear}
                        />
                      }
                    </Grid>
                  </Grid>
                </Grid>
                :
                <span className="text-muted">No services added.</span>

            }

          </CardBody>
        </Card>
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ General, Service, ServiceType }) {
  return {
    servicesTab: General.services,
    services_type: General.serviceList?.data || [],

  };
}


export default connect(mapStateToProps)(Services);
